import { useAppSelector } from 'store';
import { type PolicySummary, useGetPolicyListQuery } from 'store/api/clinicalPolicyApi';
import { useGetDiagnosesMapQuery } from 'store/api/referenceApi';

export const usePolicyListData = (): {
    policyListData?: PolicySummary[];
    isFetching: boolean;
} => {
    const { payerId } = useAppSelector((state) => state.auth);
    const { data, isFetching } = useGetPolicyListQuery({ payerId: payerId! });
    const { data: diagnosesMap } = useGetDiagnosesMapQuery();

    const policyListData = data?.map((policy) => ({
        ...policy,
        diagnoses: policy.diagnosesOids?.map((oid) => diagnosesMap?.[oid]).join(', '),
    }));

    return { policyListData, isFetching };
};
